<template lang="pug">
  .audio-player

    //audio(ref="audio")
      source(src="~assets/scenes/scene1adults.txt" type="audio/mpeg")
    //h2 {{currTime}}



</template>

<script>
import SoundService from 'src/services/SoundService'
import Raf from 'src/helpers/Raf'
import WechatService from 'src/services/WechatService'
import Subtitles from 'src/components/vca/widgets/Subtitles'
import * as MODES from 'src/config/modes'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'audio-player',
  components: {
    Subtitles
  },
  data() {
    return {

      paused: true,
      MODES,
      currTime:0,
      sound: null,
      transbgm: null,
      snapSound: null,
      vids: [],
      soundMark: [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0]
      ]

    }
  },
  props: {


  },
  computed: {
    ...mapState('browser', ['isWechat']),
    ...mapState('app', ['mode', 'currSceneIdx', 'muted', 'showGallery', 'showMenu', 'showSubtitles', 'modeSwitching', 'sceneEntered']),
  },
  mounted() {
    // 自动播放音乐效果，解决微信自动播放问题
    // if (this.isWechat)
    //   document.addEventListener("WeixinJSBridgeReady", () => {
    //     console.log('WeixinJSBridgeReady!!!!')
    //     this.playSoundFromStart(this.mode, this.currSceneIdx)
    //   }, false)
    //
    //
    // document.removeEventListener('DOMContentLoaded', ()=>{
    //   document.addEventListener("WeixinJSBridgeReady", () => {
    //     console.log('WeixinJSBridgeReady!!!!')
    //     this.playSoundFromStart(this.mode, this.currSceneIdx)
    //   }, false)
    // })
    //this.audio = this.$refs.audio


    window.AudioPlayer = this



    // let idx = ''
    // if(this.mode === MODES.KIDS){
    //   idx = `scene${this.currSceneIdx+1}kids`
    // }else{
    //   idx = `scene${this.currSceneIdx+1}adults`
    // }

    this.sound = SoundService.get('bgm')
    this.transbgm = SoundService.get('transbgm')
    this.snapSound = SoundService.get('snapshot')
    this.sound.loop = true
    this.sound.play()
    this.sound.on('end', () => {
      //console.log('EEEEENNNNNDDDDD')
      this.sound.currentTime = 0
      this.sound.play()
    })

    this.wechatAutoplay()
    document.addEventListener('visibilitychange', this.visibilityHandler)

  },
  beforeDestroy() {
    //this.sound.pause()
    document.removeEventListener('visibilitychange', this.visibilityHandler)
  },
  methods: {
    ...mapMutations('app', ['setBgm', 'playBgm']),

    visibilityHandler(){
      if (document.visibilityState === 'hidden') {
        this.muteOn()
      } else {
        this.muteOff()
      }

    },
    wechatAutoplay(){
      if (this.isWechat){
        if (typeof window.WeixinJSBridge == 'object' && typeof window.WeixinJSBridge.invoke == 'function') {
          //that.sound.play()
          WeixinJSBridge.invoke('getNetworkType', {}, (e) => {
            //this.sound.muted = true
            //this.audio.play()
            //this.playBgm()
            this.sound.play()


          }, false);
        } else {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', ()=>{
              //this.playBgm()
              this.sound.play()

            }, false)
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', ()=>{
              this.sound.play()
              //this.playBgm()

            })
            document.attachEvent('onWeixinJSBridgeReady', ()=>{
              this.sound.play()
              //this.playBgm()

            })
          }
        }
      }
    },

    playTransBgm(){
      this.sound.pause()
      this.transbgm.currentTime = 0
      this.transbgm.play()
      this.transbgm.on('end', () => {
        this.transbgm.currentTime = 0
        this.transbgm.play()
      })
    },
    stopTransBgm(){
      this.transbgm.pause()
      //this.transbgm.play()
      // this.transbgm.on('end', () => {
      //   this.transbgm.currentTime = 0
      //   this.transbgm.play()
      // })
    },
    playSnapshotSound(){
      this.snapSound.play()
    },

    muteOn(){
      this.sound.pause()
      this.sound.muted = true
      this.transbgm.muted = true
      this.snapSound.muted = true
    },
    muteOff(){
      if (this.muted) return
      this.sound.muted = false
      if (!this.sceneEntered)
        this.sound.play()
      this.transbgm.muted = false
      this.snapSound.muted = false
    }


  },
  watch: {
    sceneEntered(val){
      if (val) {
        this.sound.pause()
      } else {
        this.sound.play()
      }
    },
    // modeSwitching(val){
    //   if (val) {
    //     if (this.sound) this.sound.pause()
    //     //if (this.vid) this.vid.pause()
    //   }
    // },
    // showMenu(val){
    //   if (val){
    //     if (this.sound) this.sound.pause()
    //     //if (this.vid) this.vid.pause()
    //
    //   } else{
    //     if (this.sound) this.sound.play()
    //     //if (this.vid) this.vid.play()
    //
    //   }
    // },
    // showGallery(val){
    //   if (val){
    //     if (this.sound) this.sound.pause()
    //     //if (this.vid) this.vid.pause()
    //     let spine = document.getElementById('spinePlayer')
    //     if (spine){
    //       spine.components['spine'].pause()
    //     }
    //   } else{
    //     if (this.sound) this.sound.play()
    //     //if (this.vid) this.vid.play()
    //     let spine = document.getElementById('spinePlayer')
    //     if (spine){
    //       spine.components['spine'].play()
    //     }
    //   }
    // },
    muted(val){
      if (!val){
        this.muteOff()
      }else{
        this.muteOn()
      }
    },
    // mode(val){
    //   this.playSoundFromStart(val, this.currSceneIdx)
    // },
    // currSceneIdx(val){
    //   this.playSoundFromStart(this.mode, val)
    //   //this.playVidFromStart(val)
    // }
  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.audio-player
  display: none
  //z-index: 70



</style>
